// reducers/userReducer.js
const initialState = {
    tableInfo: {},
    IsShowLoader: false,
    IsProductAdded: false,
    addedProductName: '',
    cartCount: 0,
    productCartCount: 0,
};

const mainReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_TABLE_INFO":
      return { 
        ...state,
        tableInfo: action.payload 
      };
    case "SHOW_LOADER":
      return { 
        ...state,
        IsShowLoader: action.payload 
      };
    
    case "PRODUCT_ADDED_SUCCESS":
      return { 
        ...state,
        IsProductAdded: action.payload.IsProductAdded,
        addedProductName: action.payload.addedProductName,

      };
    case 'INCREMENT_CART_COUNT':
      return {
        ...state,
        cartCount: state.cartCount + 1,
      };
    case 'DECREMENT_CART_COUNT':
      return {
        ...state,
        cartCount: state.cartCount - 1,
      };
    case 'PRODUCT_CART_COUNT':
      return {
        ...state,
        productCartCount: action.payload,
      }
    default:
      return state;
  }
};

export default mainReducer;
